import { OnChanges, Input, Component, ViewChildren, QueryList } from '@angular/core';
import { FormField, RadioGroupInterface } from '../models/form-field';
import { FormGroup } from '@angular/forms';
import { DynamicFormFieldComponent } from './dynamic-form-field.component';
import { RadioFieldComponent } from './radio-field.component';
import { Util } from '../utils/utils.module';


@Component({
  selector: 'edx-radio-group',
  styleUrls: ['dynamic-form-field.component.scss'],
  templateUrl: 'radio-group.component.html',
  standalone: false
})
export class RadioGroupComponent implements RadioGroupInterface, OnChanges {
  @ViewChildren(RadioFieldComponent) buttons: QueryList<RadioFieldComponent>;
  @Input() field: FormField;
  @Input() form: FormGroup;
  @Input() parent?: DynamicFormFieldComponent;
  @Input() inDialog?: boolean = false;
  @Input() formReadonly?: boolean = false;
  @Input() columnView?: boolean = false;
  @Input() inNotify?: boolean = false;
  @Input() previewOnly?: boolean = false;
  @Input() hasLabel = false;
  @Input() tabIndex = 0;
  @Input() rerender = 0;
  private viewReadonly = false;

  ngOnChanges(): void {
    setTimeout(() => {
      if (this.buttons) {
        this.buttons.forEach((item: RadioFieldComponent, index: number, array: RadioFieldComponent[]) => {
          item.ngOnChanges();
        });
      }
    }, 1);
  }

  public radioButtonOn(btn: RadioFieldComponent, value: string): void {
    this.parent.updateControlValue(value, true);
    this.parent.fieldChanged();
    if (this.parent.isAdminGroupEditFormField()) {
      this.parent.parent?.setLastAccessedSectionForChild(this.field.name);
    }
    this.buttons.forEach((item: RadioFieldComponent, index: number, array: RadioFieldComponent[]) => {
      if (item !== btn) {
        item.ngOnChanges();
      }
    });
  }

  public shiftRadioFocus(event: KeyboardEvent, rbIndex: number): void {
    if (rbIndex >= 0 && rbIndex < this.field.buttonMap.length) {
      const radioId = this.getRadioId(rbIndex);
      if (!!radioId) {
        const rbElement = document.getElementById(radioId) as HTMLElement;
        if (!!rbElement) {
          rbElement.focus();
          rbElement.click();
          event.stopPropagation();
        }
      }
    } else if (rbIndex < 0 && this.parent?.isAdminGroupConfig()) {
      Util.Transforms.focusOnElementByClassName('fileitem selected');
    }
  }

  public getRadioId(index: number): string {
    return !!this.field.name ? ('edx_radio_' + this.field.name + '_' + index) : null;
  }
}
